export default {
    props: [
        "title",
        "message_first",
        "message_second"
    ]
}